export const DATE_ONLY_FORMAT = 'yyyy-MM-dd'

const DATE_ONLY_PATTERN = /^(\d{4}-\d{2}-\d{2})$/
const ISO_DATE_TIME_PATTERN = /^(\d{4}-\d{2}-\d{2})T/
const UTC_MIDNIGHT_PATTERN =
  /^(\d{4}-\d{2}-\d{2})T00:00:00(?:\.000)?(?:Z|\+00:00)$/

const padDatePart = (value: number) => String(value).padStart(2, '0')

export const formatLocalDateOnly = (date: Date): string | undefined => {
  if (Number.isNaN(date.getTime())) return undefined

  return [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate()),
  ].join('-')
}

export const formatUtcDateOnly = (date: Date): string | undefined => {
  if (Number.isNaN(date.getTime())) return undefined

  return [
    date.getUTCFullYear(),
    padDatePart(date.getUTCMonth() + 1),
    padDatePart(date.getUTCDate()),
  ].join('-')
}

export const isValidDateOnly = (value: string): boolean => {
  const date = new Date(`${value}T00:00:00.000Z`)

  return formatUtcDateOnly(date) === value
}

export const resolveDateOnlyFromString = (
  value: string,
): string | undefined => {
  const trimmed = value.trim()
  if (!trimmed) return undefined

  const dateOnly =
    DATE_ONLY_PATTERN.exec(trimmed)?.[1] ??
    UTC_MIDNIGHT_PATTERN.exec(trimmed)?.[1]
  if (dateOnly) return isValidDateOnly(dateOnly) ? dateOnly : undefined

  const isoDateOnly = ISO_DATE_TIME_PATTERN.exec(trimmed)?.[1]
  if (!isoDateOnly || !isValidDateOnly(isoDateOnly)) return undefined

  return formatLocalDateOnly(new Date(trimmed))
}

export const serializeDateOnlyAsUtcMidnight = (dateOnly: string): string =>
  `${dateOnly}T00:00:00.000Z`
